export class CalendarEventExcludedDateListDTO {

    id: string;

    excludedDate: Date | string;

}
